<div class="divContent">
  <mat-accordion class="acordeonContent">
    <mat-expansion-panel
      hideToggle
      [expanded]="panelOpenState"
      class="mat-elevation-z4"
    >
      <mat-expansion-panel-header
        class="acordeonHeader"
        (click)="ocultarMostrar()"
      >
        <div class="topTitle">
          <mat-card class="titleSeccion">
            <span *ngIf="!editarValor">Crear sucursal</span>
            <span *ngIf="editarValor">Editar sucursal</span>
            <mat-icon *ngIf="!panelOpenState" class="iconArrow"
              >keyboard_arrow_down</mat-icon
            >
            <mat-icon *ngIf="panelOpenState" class="iconArrow"
              >keyboard_arrow_up</mat-icon
            >
          </mat-card>
        </div>
      </mat-expansion-panel-header>

      <form
        [formGroup]="sucursalForm"
        (submit)="guardarSucursal(sucursalForm.value)"
        class="formCard"
      >
        <div class="card">
          <div class="formGroup">
            <input hidden matInput formControlName="id" />
          </div>
          <div class="formGroup">
            <mat-form-field class="example-full-width input" appearance="fill">
              <mat-label>Nombre</mat-label>
              <input
                type="text"
                formControlName="nombre"
                matInput
                (ngModelChange)="clearNombre()"
              />
            </mat-form-field>
            <div class="valid">
              <span
                style="color: rgb(236, 75, 72)"
                *ngIf="
                  sucursalForm.get('nombre').errors?.required &&
                  sucursalForm.get('nombre').touched
                "
              >
                El nombre es requerido
              </span>
              <span style="color: rgb(236, 75, 72)" *ngIf="errorNombre">
                La nombre fue registrado para otra sucursal
              </span>
            </div>
          </div>
          <div class="formGroup">
            <mat-form-field class="example-full-width input" appearance="fill">
              <mat-label>Dirección</mat-label>
              <input type="text" formControlName="direccion" matInput />
            </mat-form-field>
            <div class="valid">
              <span
                style="color: rgb(236, 75, 72)"
                *ngIf="
                  sucursalForm.get('direccion').errors?.required &&
                  sucursalForm.get('direccion').touched
                "
              >
                La dirección es requerida
              </span>
            </div>
          </div>
          <div class="formGroup telefonoForm">
            <div class="tefonoPais">
              <mat-form-field appearance="fill" class="telefonoInput1">
                <mat-label>Teléfono país</mat-label>
                <mat-select formControlName="telPais">
                  <mat-option>
                    <ngx-mat-select-search
                      id="telPais"
                      [noEntriesFoundLabel]="'Not found'"
                      [placeholderLabel]="'Buscador'"
                      [formControl]="telPais"
                      name="filterPost"
                      (ngModelChange)="filtrarTelPais($event)"
                    >
                    </ngx-mat-select-search>
                  </mat-option>
                  <mat-option
                    *ngFor="let tel of filtroTelefonoPais"
                    [value]="tel.codigo"
                  >
                    {{ tel.nombre }} ({{ tel.codigo }})
                  </mat-option>
                </mat-select>
              </mat-form-field>
              <div class="valid">
                <span
                  style="color: rgb(236, 75, 72)"
                  *ngIf="
                    sucursalForm.get('telPais').errors?.required &&
                    sucursalForm.get('telPais').touched
                  "
                >
                  El teléfono país es requerido
                </span>
              </div>
            </div>
            <div class="tefonoCaract">
              <mat-form-field
                class="example-full-width"
                class="input telefonoInput2"
                appearance="fill"
              >
                <mat-label>teléfono caract.</mat-label>
                <input formControlName="telCaract" type="text" matInput />
              </mat-form-field>
              <div class="valid">
                <span
                  style="color: rgb(236, 75, 72)"
                  *ngIf="
                    sucursalForm.get('telCaract').errors?.required &&
                    sucursalForm.get('telCaract').touched
                  "
                >
                  La característica es requerida
                </span>
              </div>
            </div>
            <div class="tefonoNumero">
              <mat-form-field
                class="example-full-width"
                class="input telefonoInput3"
                appearance="fill"
              >
                <mat-label>Teléfono número</mat-label>
                <input formControlName="telNumero" type="text" matInput />
              </mat-form-field>
              <div class="valid">
                <span
                  style="color: rgb(236, 75, 72)"
                  *ngIf="
                    sucursalForm.get('telNumero').errors?.required &&
                    sucursalForm.get('telNumero').touched
                  "
                >
                  El número de teléfono es requerida
                </span>
              </div>
            </div>
          </div>
          <div class="formGroup">
            <mat-form-field class="example-full-width input" appearance="fill">
              <mat-label>Email</mat-label>
              <input
                type="email"
                formControlName="email"
                matInput
                (ngModelChange)="clearEmail()"
              />
            </mat-form-field>
            <div class="valid">
              <span
                style="color: rgb(236, 75, 72)"
                *ngIf="
                  sucursalForm.get('email').errors?.required &&
                  sucursalForm.get('email').touched
                "
              >
                El email es requerido
              </span>
              <span
                style="color: rgb(236, 75, 72)"
                *ngIf="
                  sucursalForm.get('email').errors?.email &&
                  sucursalForm.get('email').touched
                "
              >
                El email no tiene el formato correcto
              </span>
              <span style="color: rgb(236, 75, 72)" *ngIf="errorEmail">
                La email fue registrado para otra sucursal
              </span>
            </div>
          </div>
          <div class="formGroup">
            <mat-form-field class="formFile">
              <div class="myfilebrowser">
                <mat-toolbar>
                  <input
                    matInput
                    [(ngModel)]="myfilename"
                    readonly
                    formControlName="memberContactNo"
                  />
                  <button mat-raised-button class="fileButton" color="primary">
                    Buscar
                  </button>
                </mat-toolbar>
                <input
                  type="file"
                  #UploadFileInput
                  id="fileUpload"
                  (change)="fileChangeEvent($event)"
                  name="fileUpload"
                  multiple="multiple"
                  accept="image/*"
                />
              </div>
            </mat-form-field>
            <p class="textAclaration">
              Imagen debe contar con el mismo alto y ancho, max 1200*1200
            </p>
          </div>
          <div #divImagen class="divImagen">
            <img #mostrarImagen class="imagen" [src]="imagen" />
          </div>
          <div>
            <span style="color: rgb(236, 75, 72)" *ngIf="errorImage">
              La imagen es requerida
            </span>
          </div>
          <div class="formButton">
            <button *ngIf="!editarValor" mat-raised-button class="buttonForm">
              Crear
            </button>
            <button
              *ngIf="editarValor"
              mat-raised-button
              class="buttonForm Cancelar"
              routerLink="../../"
            >
              Cancelar
            </button>
            <button *ngIf="editarValor" mat-raised-button class="buttonForm">
              Editar
            </button>
          </div>
        </div>
      </form>
    </mat-expansion-panel>
  </mat-accordion>
</div>
